import React, { useState } from 'react';
import { bulkUpdateUserRoles } from '../../../services/supabaseService';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkRoleModal = ({ userIds, onClose, onSuccess }) => {
  const [selectedRole, setSelectedRole] = useState('sales');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const updatedCount = await bulkUpdateUserRoles(userIds, selectedRole);
      if (updatedCount > 0) {
        onSuccess?.();
      } else {
        setError('No users were updated');
      }
    } catch (err) {
      console.error('Error updating roles:', err);
      setError(err?.message || 'Failed to update roles');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Bulk Role Assignment</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
              <Icon name="AlertCircle" size={20} className="text-red-500" />
              <p className="text-red-700">{error}</p>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              You are about to assign a new role to <strong>{userIds?.length}</strong> user(s).
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Select New Role *</label>
            <Select value={selectedRole} onChange={(e) => setSelectedRole(e?.target?.value)} required>
              <option value="sales">Sales</option>
              <option value="center_manager">Center Manager</option>
              <option value="admin">Admin</option>
            </Select>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? 'Updating...' : 'Assign Role'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkRoleModal;